module.exports = __webpack_public_path__ + "static/media/logo_comunicaciones_recortado.39d7d202.jpeg";